import { useEffect, useState } from 'react';

import Axios from '../networking/interceptor';
import { driver_patient_delivery } from '../networking/urlEndPoints';
import { getDeliveredHistoryRx } from '../utils/helper/deliveredRxDisplay';

// Loads today's already delivered Rxs for one patient card (display only).
// Kept in local state so it never touches the patient-detail redux slice used
// by the search page. Any failure just shows no history.
const useDeliveredRxHistory = ({ patientId, pharmacyId, pendingRxData, enabled }) => {
	const [historyRx, setHistoryRx] = useState([]);

	// Refetch when the pending Rxs change (e.g. after a dose is delivered).
	const pendingKey = (pendingRxData || []).map((rx) => `${rx?.id}:${rx?.delivery_status}`).join(',');

	useEffect(() => {
		setHistoryRx([]);
		if (!enabled || !patientId || !pharmacyId) return;

		let cancelled = false;
		Axios.get(`${driver_patient_delivery}/${patientId}?pharmacy_id=${pharmacyId}`)
			.then((response) => {
				if (cancelled) return;
				setHistoryRx(getDeliveredHistoryRx(response?.data?.data?.patients_win_rx_data, pendingRxData));
			})
			.catch(() => {
				if (!cancelled) setHistoryRx([]);
			});

		return () => {
			cancelled = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [enabled, patientId, pharmacyId, pendingKey]);

	return historyRx;
};

export default useDeliveredRxHistory;
